import { render, staticRenderFns } from "./eb-logo.vue?vue&type=template&id=6a1f42e6&"
import script from "./eb-logo.vue?vue&type=script&lang=js&"
export * from "./eb-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports